(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations1"] && !Shopify.designMode) return;
  try {
    

  function faettonRecommendationRandomNumber() {
    if (window.crypto && window.crypto.getRandomValues) {
      try {
        var values = new Uint32Array(1);
        window.crypto.getRandomValues(values);
        return values[0] / 4294967296;
      } catch (error) {}
    }
    return Math.random();
  }

  function initFaettonRandomRecommendations(root) {
    root = root || document;

    var sliders = [];
    if (root.matches && root.matches('[data-faetton-random-pool="true"]')) {
      sliders = [root];
    } else {
      sliders = Array.prototype.slice.call(root.querySelectorAll ? root.querySelectorAll('[data-faetton-random-pool="true"]') : []);
    }

    sliders.forEach(function(slider) {
      if (!slider || slider.dataset.faettonRandomized === '1') return;
      slider.dataset.faettonRandomized = '1';

      var limit = parseInt(slider.getAttribute('data-faetton-random-limit'), 10);
      if (!limit || limit < 1) limit = 12;

      var cards = Array.prototype.slice.call(slider.querySelectorAll('[data-faetton-random-card], .productx, .thumbnail'));
      if (!cards.length) {
        slider.classList.add('is-randomized');
        return;
      }

      var shuffled = cards.map(function(card, index) {
        return {
          card: card,
          index: index,
          score: faettonRecommendationRandomNumber()
        };
      }).sort(function(a, b) {
        return a.score - b.score;
      }).map(function(item) {
        return item.card;
      });

      if (shuffled.length > 2 && shuffled[0] === cards[0]) {
        var swapIndex = Math.min(shuffled.length - 1, 1 + Math.floor(faettonRecommendationRandomNumber() * (shuffled.length - 1)));
        var first = shuffled[0];
        shuffled[0] = shuffled[swapIndex];
        shuffled[swapIndex] = first;
      }

      var selected = shuffled.slice(0, Math.min(limit, shuffled.length));
      var fragment = document.createDocumentFragment();

      selected.forEach(function(card) {
        card.style.display = '';
        fragment.appendChild(card);
      });

      cards.forEach(function(card) {
        if (selected.indexOf(card) === -1 && card.parentNode) {
          card.parentNode.removeChild(card);
        }
      });

      slider.appendChild(fragment);
      slider.scrollLeft = 0;
      slider.classList.add('is-randomized');
    });
  }

  function initFaettonRecommendationGalleries(root) {
    root = root || document;
    var galleries = root.querySelectorAll('[data-faetton-rec-gallery]');

    galleries.forEach(function(gallery) {
      if (gallery.dataset.faettonGalleryReady === '1') return;
      gallery.dataset.faettonGalleryReady = '1';

      var track = gallery.querySelector('[data-faetton-rec-track]');
      var slides = gallery.querySelectorAll('.faetton-rec-gallery__image');
      var dots = gallery.querySelectorAll('.faetton-rec-gallery__dot');
      var prev = gallery.querySelector('.faetton-rec-gallery__arrow--prev');
      var next = gallery.querySelector('.faetton-rec-gallery__arrow--next');

      if (!track || slides.length <= 1) return;

      function setActive(index) {
        dots.forEach(function(dot, dotIndex) {
          dot.classList.toggle('is-active', dotIndex === index);
        });
      }

      function currentIndex() {
        var width = slides[0] && slides[0].offsetWidth ? slides[0].offsetWidth : gallery.offsetWidth;
        return Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / Math.max(1, width))));
      }

      function goTo(index) {
        var safeIndex = Math.max(0, Math.min(slides.length - 1, index));
        track.scrollTo({ left: slides[safeIndex].offsetLeft, behavior: 'smooth' });
        setActive(safeIndex);
      }

      if (prev) {
        ['pointerdown', 'mousedown', 'touchstart'].forEach(function(type) {
          prev.addEventListener(type, function(event) {
            event.stopPropagation();
          }, { passive: true });
        });
        prev.addEventListener('click', function(event) {
          event.preventDefault();
          event.stopPropagation();
          if (event.stopImmediatePropagation) event.stopImmediatePropagation();
          goTo(currentIndex() - 1);
        });
      }

      if (next) {
        ['pointerdown', 'mousedown', 'touchstart'].forEach(function(type) {
          next.addEventListener(type, function(event) {
            event.stopPropagation();
          }, { passive: true });
        });
        next.addEventListener('click', function(event) {
          event.preventDefault();
          event.stopPropagation();
          if (event.stopImmediatePropagation) event.stopImmediatePropagation();
          goTo(currentIndex() + 1);
        });
      }

      var raf = null;
      track.addEventListener('scroll', function() {
        if (raf) return;
        raf = requestAnimationFrame(function() {
          raf = null;
          setActive(currentIndex());
        });
      }, { passive: true });
    });
  }

  function initFaettonRecommendationMainSliders(root) {
    root = root || document;
    var sections = [];

    if (root.matches && root.matches('.recommendations_section')) {
      sections = [root];
    } else {
      sections = Array.prototype.slice.call(root.querySelectorAll ? root.querySelectorAll('.recommendations_section') : []);
    }

    sections.forEach(function(section) {
      var slider = section.querySelector('.recommendations_list, .mac-cards');
      var prevButtons = Array.prototype.slice.call(section.querySelectorAll('[data-faetton-rec-prev]'));
      var nextButtons = Array.prototype.slice.call(section.querySelectorAll('[data-faetton-rec-next]'));

      if (!slider || (!prevButtons.length && !nextButtons.length)) return;
      if (section.dataset.faettonMainSliderReady === '1') return;
      section.dataset.faettonMainSliderReady = '1';

      function getCards() {
        return Array.prototype.slice.call(slider.querySelectorAll('.productx, .thumbnail')).filter(function(card) {
          return card && card.offsetParent !== null;
        });
      }

      function nearestIndex(cards) {
        var left = slider.scrollLeft;
        var bestIndex = 0;
        var bestDistance = Infinity;

        cards.forEach(function(card, index) {
          var distance = Math.abs(card.offsetLeft - left);
          if (distance < bestDistance) {
            bestDistance = distance;
            bestIndex = index;
          }
        });

        return bestIndex;
      }

      function updateButtons(index, total) {
        prevButtons.forEach(function(btn) { btn.classList.toggle('disable', index <= 0); });
        nextButtons.forEach(function(btn) { btn.classList.toggle('disable', index >= total - 1); });
      }

      function go(direction) {
        var cards = getCards();
        if (!cards.length) return;

        var current = nearestIndex(cards);
        var currentLeft = cards[current] ? cards[current].offsetLeft : 0;

        if (direction > 0 && Math.abs(slider.scrollLeft - currentLeft) < 3) {
          current += 1;
        } else if (direction < 0) {
          current -= 1;
        }

        var targetIndex = Math.max(0, Math.min(cards.length - 1, current));
        var target = cards[targetIndex];
        if (!target) return;

        slider.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
        updateButtons(targetIndex, cards.length);
      }

      function refreshState() {
        var cards = getCards();
        if (!cards.length) return;
        updateButtons(nearestIndex(cards), cards.length);
      }

      function bindButton(button, direction) {
        if (!button || button.dataset.faettonRecBound === '1') return;
        button.dataset.faettonRecBound = '1';

        ['pointerdown', 'mousedown', 'touchstart'].forEach(function(type) {
          button.addEventListener(type, function(event) {
            event.stopPropagation();
          }, { passive: true });
        });

        button.addEventListener('click', function(event) {
          event.preventDefault();
          event.stopPropagation();
          if (event.stopImmediatePropagation) event.stopImmediatePropagation();
          go(direction);
        }, true);
      }

      prevButtons.forEach(function(button) { bindButton(button, -1); });
      nextButtons.forEach(function(button) { bindButton(button, 1); });

      var raf = null;
      slider.addEventListener('scroll', function() {
        if (raf) return;
        raf = requestAnimationFrame(function() {
          raf = null;
          refreshState();
        });
      }, { passive: true });

      refreshState();
    });
  }

  var loadProductRecommendationsIntoSection = function() {
    var productRecommendationsSection = document.querySelector(".product-recommendations");
    if (productRecommendationsSection === null) { return; }
    if (productRecommendationsSection.getAttribute("data-faetton-recommendations-enabled") === "false") { return; }
    var productId = productRecommendationsSection.dataset.productId;
    var limit = productRecommendationsSection.dataset.limit;
    var requestUrl = "/recommendations/products?section_id=product-recommendations1&limit=" + limit + "&product_id=" + productId;
    var request = new XMLHttpRequest();
    request.open("GET", requestUrl);
    request.onload = function() {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement("div");
        container.innerHTML = request.response;
        var returned = container.querySelector(".product-recommendations");

        if (returned) {
          // Preenche popup (se existir) e já ativa os controles dentro dele.
          var popup = document.querySelector(".recommended-popup");
          if (popup) {
            popup.innerHTML = returned.innerHTML;
            initFaettonRandomRecommendations(popup);
            initFaettonRecommendationGalleries(popup);
            initFaettonRecommendationMainSliders(popup);
          }

          // Substitui a seção no DOM (comportamento igual ao seu original)
          var parentContainer = productRecommendationsSection.parentElement;
          parentContainer.innerHTML = returned.innerHTML;

          initFaettonRandomRecommendations(parentContainer);
          initFaettonRecommendationGalleries(parentContainer);

          initFaettonRecommendationMainSliders(parentContainer);
        }
      }
    };
    request.send();
  };

  document.addEventListener("shopify:section:load", function(event) {
    if (event.detail.sectionId === "product-recommendations") {
      loadProductRecommendationsIntoSection();
    }
  });
  initFaettonRandomRecommendations(document);
  initFaettonRecommendationGalleries(document);
  initFaettonRecommendationMainSliders(document);
  loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
